import React from 'react';
import {
  Box,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Button,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import CampaignIcon from '@mui/icons-material/Campaign';

type Props = {
  title: string;
  subtitle: string;
  onRefresh: () => void;
  onSendAll: () => void;
  disableActions: boolean;
  sendLabel: string;
};

const HeaderRow: React.FC<Props> = ({
  title,
  subtitle,
  onRefresh,
  onSendAll,
  disableActions,
  sendLabel,
}) => {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      alignItems={{ xs: 'flex-start', md: 'center' }}
      justifyContent="space-between"
      rowGap={1.5}>
      <Box>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2" color="text.secondary" mt={0.5}>
          {subtitle}
        </Typography>
      </Box>

      <Stack direction="row" spacing={1} alignItems="center">
        <Tooltip title="Refresh">
          <span>
            <IconButton
              aria-label="Refresh check-ins"
              onClick={onRefresh}
              disabled={disableActions}>
              <RefreshIcon />
            </IconButton>
          </span>
        </Tooltip>
        <Button
          variant="contained"
          color="primary"
          startIcon={<CampaignIcon />}
          onClick={onSendAll}
          disabled={disableActions}
          sx={{ textTransform: 'none' }}>
          {sendLabel}
        </Button>
      </Stack>
    </Stack>
  );
};

export { HeaderRow };
